import * as types from "./mutation-types";
import CacheHelper from "@/cacheHelper";
import { isEmpty } from "lodash";

const cacheConfig = {
  key: "WIDGET_COLLAB",
  myqKey: "WIDGET_COLLAB_MYQ",
  ttl: 60 * 5 * 1000, // 5 mins
};

const cache = new CacheHelper(cacheConfig);

/**
 * All VueX actions should go here.
 * They should check if data exists via the cache, and any api calls should be made to the /flat endpoint by default
 */
export const actions = {
  async clearCache(context) {
    cache.removeItem(cacheConfig.key);
    return Promise.resolve(cacheConfig.key);
  },
  async getLargestLimit({ rootGetters, commit }) {
    const newsWidgets = rootGetters["widgets/getWidgetsByType"](
      "collab-widget"
    );
    const limits = [];
    let largest = 10;
    if (!isEmpty(newsWidgets)) {
      newsWidgets.forEach((widget) => {
        limits.push(parseInt(widget.props.limit));
      });

      largest = limits.sort((a, b) => b - a)[0];
    }

    commit(types.SET_MAX_QUERY_SIZE, largest);
    return Promise.resolve(largest);
  },
  /**
   * Globally set the number of questions to return
   */
  setLimit({ commit }, size) {
    commit(types.SET_FEED_SIZE, size);
    return Promise.resolve(size);
  },
  /**
   * Get a feed of questions based on the users interest groups
   */
  async getUserFeed({ dispatch, rootState, commit, state }) {
    let response;

    if (cache.existsAndIsValid()) {
      response = cache.getItem(cacheConfig.key);
      commit(types.SET_FEED, response);
      return Promise.resolve(response);
    }

    // do we have interest groups?
    let grpIds = [];
    if (rootState.auth.currentUser.interestgroups) {
      grpIds = rootState.auth.currentUser.interestgroups.map((grp) => grp.id);
    }

    if (state.status !== "WORKING") {
      commit(types.SET_STATUS, "WORKING");

      try {
        commit("Questions/setFilterCategories", grpIds, { root: true });
        commit("Questions/setTabFilter", null, { root: true });
        commit("Questions/setFilterSize", state.largestQuerySize, {
          root: true,
        });
        response = await dispatch(
          "Questions/list",
          { hideClosed: true },
          {
            root: true,
          }
        );
        commit(types.SET_FEED, response);
        cache.setItem(cacheConfig.key, response, true);
        commit(types.SET_STATUS, "WAITING");
        return Promise.resolve(response);
      } catch (err) {
        commit(types.SET_STATUS, "WAITING");
        return Promise.reject(new Error(err));
      }
    }
  },

  /**
   * Get a list of questions created by the user
   */
  async getMyQuestions({ dispatch, commit, state }) {
    let response;

    if (cache.existsAndIsValid(cacheConfig.myqKey)) {
      response = cache.getItem(cacheConfig.myqKey);
      commit(types.SET_FEED, response);
      return Promise.resolve(response);
    }

    try {
      commit("Questions/setFilterCategories", [], { root: true });
      commit("Questions/setTabFilter", "my-questions", { root: true });
      commit("Questions/setFilterSize", state.largestQuerySize, { root: true });
      response = await dispatch("Questions/list", null, {
        root: true,
      });
      commit(types.SET_USER_FEED, response);
      cache.setItem(cacheConfig.myqKey, response, true);
      return Promise.resolve(response);
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  },
};
